<template>
  <div class="saleOverview">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @changeContract="changeContract"
      @changeContractMatter="changeContractMatter"
      @changeProject="changeProject"
    >
    </SiruiSearch>

    <!--内容区域-->
    <div class="main-content">
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :columns="columnListDefault"
        :showFooter="true"
        :footerMethod="footerMethod"
        rowKey="contractNo"
        @sortChangeEvent="sortChangeEvent"
        @dblclickEvent="dblclickEvent"
        @chooseClick="chooseClick"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :sortable="item.sortable"
          :formatter="item.formatter"
          :field="item.field"
          :title="item.title"
        >
          <template slot-scope="scope">
            <span v-if="item.dictType">
              {{ scope.row[item.field] | getDictNameByCode(item.dictType) }}
            </span>
            <span v-else-if="item.format">
              {{ scope.row[item.field] | formatTableColumn(item.format) }}
            </span>
            <span v-else-if="item.field == 'isFixedPrice'">
              {{ scope.row[item.field] == '1' ? '是' : '否' }}
            </span>
            <template v-else-if="item.field == 'oaUrl'">
              <a
                href="javascript:void(0);"
                v-if="scope.row[item.field]"
                @click="goOaLink(scope.row[item.field])"
                >查看</a
              >
            </template>
            <template v-else-if="['contractTotalAmount'].includes(item.field)">{{
              replaceZeroStr(scope.row[item.field])
            }}</template>
            <template v-else-if="['businessContractUnitPrice'].includes(item.field)">{{
              replaceLastZeroStr(scope.row[item.field])
            }}</template>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <choiceType ref="choiceType" />
    <originals-received-dialog
      ref="OriginalsReceivedDialog"
      :vFlag="'sale'"
      @confirm="resetBtnClick"
    />
    <SiruiUpload
      ref="siruiUpload"
      @getData="getData"
      isShowDownTemplateBtn
      :action="action"
      :data="importData"
    />
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import tableMixins from '@/common/mixins/table.js';
  import API from '@/api/purchaseSalesCenter/purchaseSales.js';
  import DataBaseAPI from '@/api/dataBase';
  import choiceType from '../../components/choiceType';
  import SiruiUpload from '@/components/SiruiUpload';
  import { filterEmpty, isSearchEmpty, toLine } from '@/common/js/util';
  // import InputNumber from '@/components/form-item/input-number';
  import OriginalsReceivedDialog from '../../components/originalsReceivedDialog.vue';
  import { baseSearchColumns, baseColumnListDefault } from './saleOverview.js';
  export default {
    name: 'saleOverview',
    mixins: [tableMixins],
    components: {
      choiceType,
      SiruiUpload,
      // InputNumber,
      OriginalsReceivedDialog,
    },
    data() {
      return {
        // footerTotalCols: { amount: ['contractTotalAmount'], quantity: ['productQuantity'] }, //底部合计列-字段名，数字类型（金额amount，数量quantity等）判断小数点
        query: {
          //新加字段
          contractName: null,
          projectInitiationNo: null,
          projectName: null,
          personCharge: null,
          signDateStart: null,
          signDateEnd: null,
          contractValidStartBegin: null,
          contractValidStartFinish: null,
          contractValidEndBegin: null,
          contractValidEndFinish: null,
          recyclingCompanyFileNo: null,
          recyclingCompanyName: null,
          platformCompanyFileNo: null,
          platformCompanyName: null,
          contractMatter: null,
          materialType: null,
          deliverType: null,
          settlementDate: null,
          incomeMethod: null,
          isDefault: null,
          overduePeriodStart: null,
          overduePeriodEnd: null,
          liquidatedDamagesType: null,
          liquidatedFixedValueStart: null,
          liquidatedFixedValueEnd: null,
          liquidatedInterestRateStart: null,
          liquidatedInterestRateStartEnd: null,
          qualityGuaranteeDepositMethodCode: null,
          chargeFixedValueStart: null,
          chargeFixedValueEnd: null,
          chargeProportionStart: null,
          chargeProportionEnd: null,
          qualityGuaranteeDepositOverdueStart: null,
          qualityGuaranteeDepositOverdueEnd: null,
          marginAmountStart: null,
          marginAmountEnd: null,
          performanceBondPayMethodCode: null,
          performanceBondPayMethodName: null,
          receiptMethod: null,
          //新加字段
          contractDetailCategory: null,
          externalContractNo: null,
          intentionNo: null,
          contractNo: null,
          tradeType: null,
          contractCreateStartDate: null,
          pricingRule: null,
          contractCreateEndDate: null,
          storage: null,
          amountStart: undefined,
          amountEnd: undefined,
          customer: null,
          product: null,
          settleBatchNumber: null,
          priceStart: undefined,
          priceEnd: undefined,
          quantityStart: undefined,
          quantityEnd: undefined,
          payerName: null,
          //receiptCondition: null,
          contractCreateDate: null,
          contractStatus: null,
          lastestReceiveMoneyDay: null,
          lastestSendProductDay: null,
          supplychain: null,
          contractBusinessCompanyNo: null,
          contractBusinessDepartment: null,
          contractSalesman: null,
          contractOperaterNo: null,
          businessType: null,
          isFixedPrice: null,
          isCreditsale: null,
          ladingQuantityJudgeFlag: null,
          ladingQuantity: null,
          unLadingQuantityJudgeFlag: null,
          unLadingQuantity: null,
          isNotProxy: null, //贸易合同-非代理,1-是,0-否'
          distributionBatchNo: null,
          originalsReceivedBusiness: null,
          originalsReceivedRm: null,
          isPersonalPartner: null,
        },
        instructionTypeList: [], //交货方式
        intDisabled: false,
        contDisabled: false,
        //排序条件
        sortParams: '',
      };
    },
    computed: {
      action() {
        return API.IMPORT_ORDER_API;
      },
      searchColumns() {
        return baseSearchColumns(this);
      },
      columnListDefault() {
        return baseColumnListDefault;
      },
      ...mapState({
        userInfo: (state) => state.userInfo,
        lang: (state) => state.lang.language,
      }),
      //导入额外参数
      importData() {
        return {
          tenantCode: this.userInfo.userInfo.tenantCode,
          companyCode: this.userInfo.userInfo.companyCode,
          companyName: this.userInfo.userInfo.companyName,
          departmentCode: this.userInfo.userInfo.departmentCode,
          departmentName: this.userInfo.userInfo.departmentName,
          belongTenantCode: this.userInfo.userInfo.tenantCode,
          dataGroup: this.$globalVar.dataGroup,
          access_token: this.userInfo.userInfo.access_token,
          lang: this.lang,
        };
      },
    },
    mounted() {
      if (this.$route.query.contractDetailCategory) {
        this.query.contractDetailCategory = this.$route.query.contractDetailCategory;
        this.getData();
      }
      this.$nextTick(() => {
        this.getButtonList();
        this.getData();
      });
    },
    activated() {
      this.getData();
    },
    watch: {
      $route() {
        this.getData(); // 监听路由变动调用接口
      },
    },
    methods: {
      footerMethod({ columns, data }) {
        return [
          columns.map((column, columnIndex) => {
            if (columnIndex === 0) {
              return '合计';
            }
            if (['contractTotalAmount'].includes(column.property)) {
              return this.replaceZeroStr(
                data.reduce((cur, next) => cur + +next.contractTotalAmount, 0).toFixed(2)
              );
            } else if (['productQuantity'].includes(column.property)) {
              return this.replaceLastZeroStr(
                data.reduce((cur, next) => cur + +next.productQuantity, 0).toFixed(2)
              );
            }
            return null;
          }),
        ];
      },
      //获取数据
      getData() {
        let count = Object.keys(this.query).length;
        for (var key in this.$refs.siruiSearch.query) {
          if (
            this.$refs.siruiSearch.query[key] == null ||
            this.$refs.siruiSearch.query[key] == undefined ||
            this.$refs.siruiSearch.query[key] === ''
          ) {
            count = count - 1;
          }
        }
        //如果不选制单类型  但是同时输入了意向单和合同号 提示报错
        if (
          this.$refs.siruiSearch.query.intentionNo &&
          this.$refs.siruiSearch.query.contractNo &&
          this.$refs.siruiSearch.query.contractDetailCategory == null
        ) {
          this.$message({
            showClose: true,
            message: '请选择制单类型',
            type: 'error',
          });
          return;
        }
        if (!this.load) {
          let params = this.getQueryData();
          //默认 制单日期倒叙
          params.orderByDesc = this.sortParams;
          params.dataGroup = this.$globalVar.dataGroup;
          params.pageSize = this.$refs.siruiTable.page.pageSize;
          params.pageNum = this.$refs.siruiTable.page.pageNum;
          params.companyCode = this.userInfo.userInfo.companyCode;
          params.departmentCode = this.userInfo.userInfo.departmentCode;
          params.businessGroup = this.userInfo.userInfo.businessGroup;
          this.load = true;
          this.$axios
            .post(API.GET_LIST_API, {
              ...params,
              contractBusinessDepartment: params.contractBusinessDepartment
                ? params.contractBusinessDepartment
                : null,
            })
            .then((res) => {
              this.load = false;
              this.query.contractCategory = null;
              if (0 == res.data.code) {
                this.tableData = res.data.data.list;
                if (this.$refs.siruiTable) {
                  this.$refs.siruiTable.setPageTotal(res.data.data.total);
                }
              } else {
                this.$alert(res.data.msg);
              }
            });
        }
        let tenantCode = this.userInfo.userInfo.tenantCode;
        //交货方式
        this.$axios
          .post(DataBaseAPI.DIC_CREDIT_API, {
            dictType: 'deliver_type',
            tenantCode,
          })
          .then((res) => {
            if (0 == res.data.code) {
              this.instructionTypeList = res.data.data;
            }
          });
      },

      unique(array) {
        let temp = [];
        let index = [];
        let l = array.length;
        for (let i = 0; i < l; i++) {
          for (let j = i + 1; j < l; j++) {
            if (array[i] === array[j]) {
              i++;
              j = i;
            }
          }
          temp.push(array[i]);
          index.push(i);
        }
        return temp;
      },
      //处理查询数据
      getQueryData() {
        const query = Object.assign({}, this.$refs.siruiSearch.query);
        query.contractCategory = 'sales';
        query.groupByContractDetailNoFlag = '1'; //区分当前接口是否为采销合同调用

        if (query.personChargeCode) {
          let idList = query.personChargeCode.map((item) => item.id).join(',');
          console.log(idList);
          query.personChargeCode = idList;
        }
        //意向单和合同号是同一个字段
        //如果意向单号有值  则将意向单号传给合同号
        if (query.contractDetailCategory == null) {
          query.contractNo = query.intentionNo ? query.intentionNo : query.contractNo;
        } else {
          if (query.contractDetailCategory == 'HT04') {
            query.contractNo = query.intentionNo;
          }
        }
        //客户
        query.customerNo = this.handleData(query.customer, 'partnerCode');
        //仓库
        query.storageNo = this.handleData(query.storage, 'storageCode');
        //商品描述
        query.productNo = this.handleData(query.product, 'productDetailCode');
        //业务员
        query.contractSalesmanNo = this.handleData(query.contractSalesman, 'id');
        //操作人
        query.contractOperaterNo = this.handleData(query.contractOperaterNo, 'id');
        //供应链主体
        query.supplychainNo = this.handleData(query.supplychain, 'supplierCode');
        delete query.customer;
        //业务公司赋初值
        //query.contractBusinessCompanyNo = this.userInfo.userInfo.companyCode;
        // query.contractBusinessCompanyName = this.userInfo.userInfo.companyName;
        return filterEmpty(query);
      },
      //处理数据
      handleData(multipleSelection, key) {
        let selectList = multipleSelection ? multipleSelection : [];
        let list = [];
        selectList.forEach((item) => {
          if (key == 'partnerCode') {
            if (item.allPartnerCode && item['allPartnerCode'] != undefined) {
              list.push(item.allPartnerCode);
            } else {
              list.push(item[key]);
            }
          } else if (key == 'supplierCode') {
            //合并的数据
            if (item.allSupplierCode && item['allSupplierCode'] != undefined) {
              list.push(item.allSupplierCode);
            } else {
              list.push(item[key]);
            }
          } else if (key == 'productDetailCode') {
            //合并的数据
            if (item.allProductDetailCode && item['allProductDetailCode'] != undefined) {
              list.push(item.allProductDetailCode);
            } else {
              list.push(item[key]);
            }
          } else {
            if (item[key] && item[key] != undefined) {
              list.push(item[key]);
            }
          }
        });
        return list.length != 0 ? list.join(',') : null;
      },
      //排序
      sortChangeEvent({ property, order }) {
        if (order) {
          if (['contractTotalAmount', 'contractCreateDate'].indexOf(property) > -1) {
            this.sortParams = `tos.${toLine(property)} ${order}`;
          } else {
            this.sortParams = `tosd.${toLine(property)} ${order}`;
          }
        } else {
          this.sortParams = '';
        }
        this.getData();
      },
      //重置
      resetBtnClick() {
        //删除已经存在的字段
        delete this.query.contractCategory;
        delete this.query.pageSize;
        delete this.query.pageNum;
        delete this.query.orderByDesc;

        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.multipleSelection = [];
        this.tableData = [];
        this.$refs.siruiTable.reloadTable(this.tableData);
        this.getData();
      },

      changeContractMatter({ val }) {
        if (val && val[0]) {
          console.log(val[0]);
          this.query.contractMatter = val[0].parentProductNo;
        } else {
          this.query.contractMatter = null;
        }
      },

      changeProject({ val, prop }) {
        console.log(val, prop, '==');
        if (prop == 'projectName') {
          this.query.projectName = val ? val[0].projectAbbreviation : '';
        }
        let list = val;
        let codeList = [];
        if (list && list.length) {
          list.forEach(function (item) {
            codeList.push(item.projectInitiationNo);
          });
          this.query.projectInitiationNo = codeList.join(',');
        } else {
          this.query.projectInitiationNo = null;
        }
      },

      //搜索区域控制切换事件
      changeContract(obj) {
        let arr = ['HT05', 'HT06', 'HT07'];
        //如果是意向单,则意向单号可填，合同号禁用
        if (obj.val == 'HT08') {
          this.contDisabled = true;
          this.intDisabled = false;
          this.query.contractNo = null;
        } else if (arr.includes(obj.val)) {
          //如果是合同或协议,则合同号可填，意向单号禁用
          this.intDisabled = true;
          this.contDisabled = false;
          this.query.intentionNo = null;
        } else {
          this.intDisabled = false;
          this.contDisabled = false;
          this.query.intentionNo = null;
          this.query.contractNo = null;
        }
      },
      // 列表双击
      dblclickEvent({ row }) {
        const { contractDetailCategory, contractNo, id, contractStatus } = row;
        let path = {};
        if (contractDetailCategory == 'CG03') {
          path = {
            path: '/salePurchase/saleAgreementEdit',
            name: 'saleAgreementEdit',
            meta: {
              keepAlive: true,
              title: '销售协议编辑',
            },
            query: {
              id: id,
              type: contractDetailCategory,
              contractNo: contractNo,
              contractCategory: 'sales',
              isEdit: contractStatus === 'ZT03' ? true : false,
            },
          };
        }
        if (contractDetailCategory == 'CG04') {
          path = {
            path: '/salePurchase/saleContractEdit',
            name: 'saleContractEdit',
            meta: {
              keepAlive: true,
              title: '销售合同编辑',
            },
            query: {
              id: id,
              type: contractDetailCategory,
              contractNo: contractNo,
              contractCategory: 'sales',
              isEdit: contractStatus === 'ZT03' ? true : false,
            },
          };
        }
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
        //已生效的 只能修改关联明细和点价已经结算批次
        // this.handlePath(
        //   value.row.contractDetailCategory,
        //   value.row.contractNo,
        //   value.row.id,
        //   value.row.contractStatus
        // );
      },
      handlePath(contractDetailCategory, contractNo, id, contractStatus) {
        let pathName = '';
        let title = '';
        let url = '';
        //年度销售协议
        if (contractDetailCategory == 'HT05') {
          pathName = 'yearSaleEdit';
          title = '年度销售协议修改';
          url = '/salePurchase/yearSaleEdit';
        }
        //月度销售协议
        if (contractDetailCategory == 'HT06') {
          pathName = 'monthSaleEdit';
          title = '月度销售协议修改';
          url = '/salePurchase/monthSaleEdit';
        }
        //单次销售合同
        if (contractDetailCategory == 'HT07') {
          pathName = 'singleSaleEdit';
          title = '单次销售合同修改';
          url = '/salePurchase/singleSaleEdit';
        }
        //销售意向单
        if (contractDetailCategory == 'HT08') {
          pathName = 'saleIntentEdit';
          title = '销售意向单修改';
          url = '/salePurchase/saleIntentEdit';
        }

        //销售合同
        if (contractDetailCategory == 'CG04') {
          pathName = 'saleContractEdit';
          title = '销售合同编辑';
          url = '/salePurchase/saleContractEdit';
        }

        //销售协议
        if (contractDetailCategory == 'CG03') {
          pathName = 'saleAgreementEdit';
          title = '销售协议编辑';
          url = '/salePurchase/saleAgreementEdit';
        }

        let path = {
          path: url,
          name: pathName,
          meta: {
            keepAlive: true,
            title: title,
          },
          query: {
            id: id,
            type: contractDetailCategory,
            contractNo: contractNo,
            contractCategory: 'sales',
            isEdit: contractStatus === 'ZT03' ? true : false,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },

      close() {
        if (this.multipleSelection.length == 0) {
          this.$message({
            showClose: true,
            message: '请勾选一条已生效的数据',
            type: 'error',
          });
          return;
        }
        if (this.multipleSelection.length > 1) {
          this.$message({
            showClose: true,
            message: '请勾选一条已生效的数据',
            type: 'error',
          });
          return;
        }
        var selection = this.multipleSelection[0];
        let type = selection.contractDetailCategory;
        if (selection.contractStatus != 'ZT03' || type != 'CG04') {
          this.$message({
            showClose: true,
            message: '请勾选一条已生效的合同',
            type: 'error',
          });
          return;
        }
        this.$confirmAction('关闭合同', '是否确认关闭合同？')
          .then(() => {
            let params = {
              id: selection.id,
              operateFlag: '0',
              oaId: this.userInfo.userInfo.oaId,
            };
            this.loading.startLoading();
            this.$axios.post(API.UPDATE_OTDER_STATUS, params).then((res) => {
              this.loading.endLoading();
              this.getData();
              if (res.data.code == 0) {
                this.$message({
                  showClose: true,
                  message: '操作成功',
                  type: 'success',
                });
              } else {
                this.$message({
                  showClose: true,
                  message: res.data.msg,
                  type: 'error',
                });
              }
            });
          })
          .catch(() => {
            this.loading.endLoading();
            this.$message({
              type: 'info',
              message: '已取消',
            });
          });
        // /sales/order / updateOrderStatus
        // { "id": "162", "operateFlag": 0 }
      },
      //删除合同
      delete() {
        if (this.multipleSelection.length == 0) {
          this.$message({
            showClose: true,
            message: '请选择已保存和已驳回合同进行删除',
            type: 'error',
          });
          return;
        }
        //可删除条件
        let isDelete = true;
        for (let i = 0; i < this.multipleSelection.length; i++) {
          if (
            this.multipleSelection[i].contractStatus != 'ZT06' &&
            this.multipleSelection[i].contractStatus != 'ZT05'
          ) {
            isDelete = false;
            break;
          }
        }
        if (!isDelete) {
          let type = this.query.contractDetailCategory;
          let tips =
            type === 'HT07'
              ? '请选择已保存和已驳回合同进行删除'
              : type === 'HT08'
              ? '请选择已保存和已驳回合同进行删除'
              : '请选择已保存和已驳回合同进行删除';
          this.$message({
            showClose: true,
            message: tips,
            type: 'error',
          });
          return;
        }
        // 删除
        this.$confirmAction()
          .then(() => {
            let ids = [];
            let contractNos = [];
            this.multipleSelection.forEach((item) => {
              ids.push(item.id);
              contractNos.push(item.contractNo);
            });
            this.loading.startLoading();
            this.$axios
              .post(API.DELETE_ORDER_API, {
                ids: ids,
                contractNos: contractNos,
                oaId: this.userInfo.userInfo.oaId,
              })
              .then((res) => {
                this.loading.endLoading();
                if (0 == res.data.code) {
                  this.$message({
                    type: 'success',
                    message: '操作成功',
                  });
                  this.getNoCheckData();
                } else {
                  this.$alert(res.data.msg);
                }
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            });
          });
      },
      //申请删除合同
      deleteCommit() {
        if (this.multipleSelection.length == 0) {
          this.$message({
            showClose: true,
            message: '请至少选择一条数据进行操作',
            type: 'error',
          });
          return;
        }

        var selection = this.multipleSelection[0];
        let type = selection.contractDetailCategory;
        if (selection.contractStatus != 'ZT03' || type != 'CG04') {
          this.$message({
            showClose: true,
            message: '只有已生效的合同才能进行此操作',
            type: 'error',
          });
          return;
        }

        //已生效，合同才可以
        this.$confirmAction('提交删除申请', '是否确认提交删除申请？')
          .then(() => {
            // let ids = [];
            let contractNos = [];
            this.multipleSelection.forEach((item) => {
              contractNos.push(item.contractNo);
            });
            contractNos = this.unique(contractNos);
            this.loading.startLoading();
            this.$axios
              .post(API.DELETE_CONTRACT_COMMIT, {
                contractNos: contractNos,
                oaId: this.userInfo.userInfo.oaId,
              })
              .then((res) => {
                this.loading.endLoading();
                if (0 == res.data.code) {
                  this.$message({
                    type: 'success',
                    message: '操作成功',
                  });
                  this.getData();
                } else {
                  this.$alert(res.data.msg);
                }
              });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消',
            });
          });
      },
      //创建新单
      addBill() {
        if (this.multipleSelection.length != 1) {
          this.$message({
            showClose: true,
            message: '请选择一条已生效的合同进行创建提单',
            type: 'error',
          });
          return;
        }
        // if (this.multipleSelection[0].contractCategory != 'CG04') {
        //   this.$message({
        //     showClose: true,
        //     message: '请选择一条已生效的合同进行创建提单',
        //     type: 'error',
        //   });
        //   return;
        // }
        // //年度销售协议不可开提单条件
        // if (this.multipleSelection[0].contractDetailCategory == 'HT05') {
        //   this.$message({
        //     showClose: true,
        //     message: '年度销售协议不可开提单',
        //     type: 'error',
        //   });
        //   return;
        // }

        let type = this.multipleSelection[0].contractDetailCategory;
        if (type == 'CG03') {
          this.$message({
            showClose: true,
            message: '请勾选一条已生效的合同',
            type: 'error',
          });
          return;
        }

        //只有已生效才能提单
        if (this.multipleSelection[0].contractStatus != 'ZT03') {
          // let type = this.query.contractDetailCategory;
          // let tips =
          //   type === 'HT07'
          //     ? 'noBillContractTips'
          //     : type === 'HT08'
          //     ? 'noBillIntentionTips'
          //     : 'noBillAgreementTips';
          this.$message({
            showClose: true,
            message: '请选择一条已生效的合同进行创建提单',
            type: 'error',
          });
          return;
        }
        //需要调用接口查询 提单是否未发货或部分发货
        this.loading.startLoading();
        this.$axios
          .post(API.CHECK_ORDER_API, {
            contractNo: this.multipleSelection[0].contractNo,
            contractDetailCategory: this.multipleSelection[0].contractDetailCategory,
          })
          .then((res) => {
            this.loading.endLoading();
            if (0 == res.data.code) {
              //跳转到销售提单页面
              let path = {
                path: '/salePurchase/salesLadingbillAdd',
                name: 'salesLadingbillAdd',
                meta: {
                  keepAlive: false,
                  title: '销售提单创建',
                },
                query: {
                  contractNo: this.multipleSelection[0].contractNo,
                },
              };
              this.$store.dispatch('tagsView/addTabView', path).then(() => {
                this.$nextTick(() => {
                  this.$router.push(path);
                });
              });
            } else {
              this.$alert(res.data.msg);
            }
          });
      },
      //创建合同
      addContract() {
        if (this.multipleSelection.length != 1) {
          this.$message({
            showClose: true,
            message: '请选择一个意向单或协议',
            type: 'error',
          });
          return;
        }
        let multipleData = this.multipleSelection[0];
        //月度销售协议 和 销售意向单可以创建合同
        if (
          multipleData.contractDetailCategory != 'HT05' &&
          multipleData.contractDetailCategory != 'HT06' &&
          multipleData.contractDetailCategory != 'HT08'
        ) {
          this.$message({
            showClose: true,
            message: '只有协议和意向单才能创建合同',
            type: 'error',
          });
          return;
        }
        //只有已生效的可以创建合同
        if (multipleData.contractStatus != 'ZT03') {
          // let tips =
          //   multipleData.contractDetailCategory === 'HT08'
          //     ? 'notAddIntentionTips'
          //     : 'notAddAgreementTips';
          this.$message({
            showClose: true,
            message: '操作失败',
            type: 'error',
          });
          return;
        }
        let path = {
          path: '/salePurchase/singleSale',
          name: 'singleSale',
          meta: {
            keepAlive: true,
            title: '单次销售合同创建',
          },
          query: {
            type: 'HT07',
            contractCategory: 'sales',
            isEdit: false,
            contractNo: this.multipleSelection[0].contractNo,
          },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //复制合同
      copyContract() {
        if (this.multipleSelection.length != 1) {
          this.$message({
            showClose: true,
            message: '请勾选一条已生效的数据',
            type: 'error',
          });
          return;
        }
        // "HT05","HT06","HT07"
        //已驳回状态不可复制

        let contractStatus = this.multipleSelection[0].contractStatus;

        if (contractStatus != 'ZT03' && contractStatus != 'ZT07') {
          // let type = this.query.contractDetailCategory;
          // let tips =
          //   type === 'HT07'
          //     ? 'noCopyContractTips'
          //     : type === 'HT08'
          //     ? 'noCopyIntentionTips'
          //     : 'noCopyAgreementTips';
          this.$message({
            showClose: true,
            message: '只能复制已生效/已关闭的协议/合同',
            type: 'error',
          });
          return;
        }
        //跳转到复制即新增页面
        this.handleCopyPath(
          this.multipleSelection[0].contractDetailCategory,
          this.multipleSelection[0].contractNo
        );
      },
      handleCopyPath(contractDetailCategory, contractNo) {
        let path;
        // //年度销售协议
        // if (contractDetailCategory == 'HT05') {
        //   pathName = 'yearSale';
        //   title = '年度销售协议创建';
        //   url = '/salePurchase/yearSale';
        // }
        // //月度销售协议
        // if (contractDetailCategory == 'HT06') {
        //   pathName = 'monthSale';
        //   title = '月度销售协议创建';
        //   url = '/salePurchase/monthSale';
        // }
        // //单次销售合同
        // if (contractDetailCategory == 'HT07') {
        //   pathName = 'singleSale';
        //   title = '单次销售合同创建';
        //   url = '/salePurchase/singleSale';
        // }
        // //销售意向单
        // if (contractDetailCategory == 'HT08') {
        //   pathName = 'saleIntent';
        //   title = '销售意向单创建';
        //   url = '/salePurchase/saleIntent';
        // }
        if (contractDetailCategory == 'CG03') {
          path = {
            path: '/salePurchase/saleAgreementCreation',
            name: 'saleAgreementCreation',
            meta: {
              keepAlive: true,
              title: '销售协议创建',
            },
            query: {
              type: contractDetailCategory,
              isEdit: false,
              contractCategory: 'sales',
              copy: true,
              copyFlag: '0',
              contractNo: contractNo,
            },
          };
        }
        if (contractDetailCategory == 'CG04') {
          path = {
            path: '/salePurchase/saleContractCreation',
            name: 'saleContractCreation',
            meta: {
              keepAlive: false,
              title: '销售合同创建',
            },
            query: {
              type: contractDetailCategory,
              isEdit: false,
              contractCategory: 'sales',
              copy: true,
              copyFlag: '0',
              contractNo: contractNo,
            },
          };
        }

        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //批量提交合同
      submitContract() {
        if (this.multipleSelection.length == 0) {
          this.$message({
            showClose: true,
            message: '请选择已保存的销售合同/协议进行提交',
            type: 'error',
          });
          return;
        }
        //只有已保存的和已驳回的才可以提交
        let isSubmit = true;
        for (let i = 0; i < this.multipleSelection.length; i++) {
          if (
            !['ZT05', 'ZT06', 'ZT061', 'ZT051'].includes(this.multipleSelection[i].contractStatus)
          ) {
            isSubmit = false;
            break;
          }
        }
        if (!isSubmit) {
          // let type = this.query.contractDetailCategory;
          // let tips =
          //   type === 'HT07'
          //     ? 'noSubmitContractTips'
          //     : type === 'HT08'
          //     ? 'noSubmitIntentionTips'
          //     : 'noSubmitAgreementTips';
          this.$message({
            showClose: true,
            message: '只有已保存、已驳回、修订中、修订已驳回合同/协议才可以提交审批',
            type: 'error',
          });
          return;
        }

        // if (this.multipleSelection[0].contractCategory == 'CG04') {
        //   for (let i = 0; i < this.multipleSelection.length; i++) {
        //     if (
        //       this.multipleSelection[i].contractTotalAmount == 0 ||
        //       !this.multipleSelection[i].contractTotalAmount
        //     ) {
        //       this.$message({
        //         showClose: true,
        //         message: this.multipleSelection[i].contractNo + '合同总金额为0,无法提交',
        //         type: 'error',
        //       });
        //       return;
        //     }
        //   }
        // }
        let contractNos = [];
        this.multipleSelection.forEach((item) => {
          contractNos.push(item.contractNo);
        });
        this.$confirmAction('提交审批？', '是否确认提交审批？')
          .then(() => {
            this.loading.startLoading();
            this.$axios
              .post(API.SUBMIT_ORDER_API, {
                contractNos: contractNos,
                oaId: this.userInfo.userInfo.oaId,
              })
              .then((res) => {
                this.loading.endLoading();
                if (0 == res.data.code) {
                  this.$message({
                    type: 'success',
                    message: '操作成功',
                  });
                  this.getNoCheckData();
                } else {
                  this.$alert(res.data.msg);
                }
              });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: '已放弃提交',
            });
            this.loading.endLoading();
          });
      },
      // 导出文件
      handleExport() {
        const tableColumn = this.$refs.siruiTable.getTableColumn();
        const showColumns = [];
        tableColumn.visibleColumn.forEach((item) => {
          if (item.property) {
            if (item.property == 'isFixedPrice') {
              showColumns.push({ prop: 'isFixedPriceName', label: '不定价' });
            } else {
              showColumns.push({ prop: item.property, label: item.title });
            }
          }
        });
        showColumns.unshift({ prop: 'rowNo', label: '序号' });
        const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        //如果当前页和历史页没有记录 ，则看搜索区域
        let count = isSearchEmpty(this.query, this.$refs.siruiSearch.query);
        if (this.multipleSelection.length == 0 && selectedList.length == 0 && count == 0) {
          this.$message({
            showClose: true,
            message: '请选择至少一条数据进行导出',
            type: 'error',
          });
          return;
        }
        const query = this.getQueryData();
        const params = filterEmpty(query);
        params.dataGroup = this.$globalVar.dataGroup;
        params.idsExport = [];
        if (selectedList.length > 0) {
          selectedList.map((item) => {
            params.idsExport.push(item.id);
          });
        }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            params.idsExport.push(item.id);
          });
        }
        // 导出字段
        params.columns = JSON.stringify(showColumns);
        //默认 制单日期倒叙
        params.orderByDesc = this.sortParams;

        this.loading.startLoading();
        // 获取数据
        this.$axios.post(API.EXPORT_ORDER_API, params).then((res) => {
          this.loading.endLoading();
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      //点击按钮触发的方法
      chooseClick(type) {
        if (type == 'addOrder') {
          //如果选择了一条数据并且是年度销售协议，则可以创建月度和创建单次销售合同
          if (
            this.multipleSelection.length == 1 &&
            this.multipleSelection[0].contractDetailCategory == 'HT05' &&
            this.multipleSelection[0].contractStatus == 'ZT03'
          ) {
            this.$refs.choiceType.openDialog(true, 'salePurchase');
          } else {
            this.$refs.choiceType.openDialog(true, 'sales_contract_detail_category');
          }
        } else if (type == 'delete') {
          this.delete();
        } else if (type == 'deleteApply') {
          this.deleteCommit();
        } else if (type == 'addBill') {
          this.addBill();
        } else if (type == 'addContract') {
          this.addContract();
        } else if (type == 'copy') {
          this.copyContract();
        } else if (type == 'submit') {
          this.submitContract();
        } else if (type == 'export') {
          this.handleExport();
        } else if (type == 'import') {
          this.importOrder();
        } else if (type == 'originalsReceivedBusiness') {
          //正本收集
          this.originalsReceived('originalsReceivedBusiness');
        } else if (type == 'originalsReceivedRm') {
          //正本归档
          this.originalsReceived('originalsReceivedRm');
        } else if (type == 'close') {
          this.close();
        } else if (type == 'withdrawApprovalHandler') {
          if (!this.multipleSelection.length) {
            this.$message.error('请选择行操作');
            return;
          }
          // 判断只有审批中
          if (this.multipleSelection.some((item) => item.contractStatus != 'ZT02')) {
            this.$message.error('只有审批中才可以撤回审批');
            return false;
          }
          const contractNos = this.multipleSelection.map((item) => item.contractNo);
          this.loading.startLoading();
          this.$axios
            .post('/sales/order/batchAuditWithdrawOA', {
              contractNos: contractNos,
              oaId: this.userInfo.oaId,
            })
            .then((res) => {
              console.log(res);
              this.loading.endLoading();
              const { code, msg } = res.data;
              if (code == 0) {
                this.resetBtnClick();
                this.$message.success('撤回成功');
              } else {
                this.$message.error(msg);
              }
            })
            .catch(() => {
              this.loading.endLoading();
            });
        } else {
          this.$message({
            showClose: true,
            message: '抱歉，暂未找到执行方法',
            type: 'error',
          });
        }
      },
      //正本操作
      originalsReceived(type) {
        const selectedList = this.$refs.siruiTable
          .getCheckboxRecords()
          .concat(this.$refs.siruiTable.getCheckboxReserveRecords()); // 当前页选中
        if (selectedList.length == 0) {
          this.$message({
            showClose: true,
            message: '请至少选择一条数据！',
            type: 'error',
          });
          return;
        }
        if (selectedList.find((item) => item.contractStatus !== 'ZT03')) {
          this.$message({
            showClose: true,
            message: '只有已生效合同才能操作！',
            type: 'error',
          });
          return;
        }
        this.$refs.OriginalsReceivedDialog.openDialog(true, type, {
          contractNo: selectedList.map((item) => item.contractNo),
        });
      },
      //导入公司或部门
      importOrder() {
        this.$refs.siruiUpload.openDialog(true, '02');
      },
    },
  };
</script>
